<template>
  <div class="main" :class="{ mainIsClose: dasyncWidth }">
    <Card shadow class="header_card">
      <HEADER />
    </Card>
    <div class="viewTags">
      <!-- <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in menuCurrentList" :key="index" :to="index == 0 ? '' : item.path">
          {{ item.meta.name }}</BreadcrumbItem>
      </Breadcrumb> -->
      <tagsViews />
    </div>
    <!--页面 主体-->
    <div class="layout">
      <transition :name="transitionName" mode="out-in">
        <router-view class="child-view" />
      </transition>
    </div>
    <cellCenter></cellCenter>
    <!-- <div class="versionInfo">copyright© 麦信电梯物联网系统 V2.0 2020</div> -->
  </div>
</template>
<script>
import main from './js/main.js'
import cellCenter from './cellCenter.vue'
import tagsViews from '@/components/tagsViews.vue'

export default {
  mixins: [main],
  components: { cellCenter, tagsViews }
}

</script>
<style lang="scss" scoped>
@import "./css/main.scss";
</style>
